import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import "../../css/ListScores.css";

import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
require("highcharts/modules/accessibility")(Highcharts);

const DisplaySurveyScores = ({ key, survey, surveyIndex, chartOptions, groupName }) => {
	const { t } = useTranslation();
	let widthOfReport = "";
	if (groupName === 'Farm' || groupName === 'Facility') {
		widthOfReport = "75vw";
	}
	useEffect(() => {
		Highcharts.setOptions({
			colors: ['#DFA817', '#ff33cc', '#058DC7', '#DDDF00', '#adadad', '#24CBE5', '#92ed9d',
				'#ffb3ff', '#FFF263', '#6AF9C4', '#ff6696', '#0bb4ff', '#00ccff', '#e6d800', '#9b19f5', '#999966', '#dc0ab4',
				'#b3d4ff', '#ffcccc', '#66ffff', '#f46a9b', '#004466', '#edbf33', '#5c550a', '#4a5214', '#993333', '#27aeef',
				'#b33dc6', '#ffd9b3', '#7c1158', '#4421af', '#1a53ff', '#0d88e6', '#00b7c7', '#4775d1', '#990099', '#ebdc78', '#204ad4',
				'#008f91', '#ccfcfa', '#fbe9e9', '#9e6f00',  '#4c90ba', '#2bc2c2', '#ff80ff', '#ebfafa', '#024b7a', '#bfbf3f',
				'#805500', '#b2b0ea', '#8585ad', '#8bc1f7']
		});
	}, []);

	return (
		<div key={key}>
			<div className="row">
				<div className="col">
					<h6 style={{ marginLeft: "2vw", textAlign: 'center' }}><b><span style={{ marginRight: "30px" }}></span>{survey.groupDescription} </b></h6>
				</div>
			</div>
			<div className="row">
				<div className="col-sm-6">
					<h6 style={{ marginLeft: "2vw", float: 'left' }}><b>{'  ' + t("page.locationcompany") + ': '}</b>{survey.locationCompanyName}</h6>
				</div>
				<div className="col-sm-6">
					{(surveyIndex == 0) && (
						<h6 style={{ marginRight: "2vw", float: 'right' }}><b>{'  ' + t("page.eval.level") + ' '}</b></h6>
					)}
				</div>
			</div>
			<div className="row">
				<div className="col-sm-6">
					<h6 style={{ marginLeft: "2vw", float: 'left' }}><b>{'  ' + t("page.location") + ': '}</b>{survey.locationName}</h6>
				</div>
				<div className="col-sm-6">
					{(surveyIndex == 0) && (
						<h6 style={{ marginRight: "2vw", float: 'right' }}><b>{'  ' + t("page.ready") + ' '}</b><span className="badge result-pass-sm"> </span></h6>
					)}
				</div>
			</div>
			<div className="row">
				<div className="col-sm-6">
					<h6 style={{ marginLeft: "2vw", float: 'left' }}><b>{'  ' + t("page.product") + ': '}</b>{survey.productNames}</h6>
				</div>
				<div className="col-sm-6">
					{(surveyIndex == 0) && (
						<h6 style={{ marginRight: "2vw", float: 'right' }}><b>{'  ' + t("page.inspect") + ' '}</b><span className="badge result-medium-sm"> </span></h6>
					)}
				</div>
			</div>
			<div className="row">
				<div className="col-sm-6">
					<h6 style={{ marginLeft: "2vw", float: 'left' }}><b><span style={{ marginRight: "30px" }}>{t("page.eval")}</span></b>{'  '}<span className={(survey.scoreResult ? ((survey.scoreResult === "L") ? "badge result-pass" : ((survey.scoreResult === "M") ? "badge result-medium" : ((survey.scoreResult === "H") ? "badge result-fail" : ""))) : "badge result-incomplete")}> </span> </h6>
				</div>
				<div className="col-sm-6">
					{(surveyIndex == 0) && (
						<h6 style={{ marginRight: "2vw", float: 'right' }}><b>{'  ' + t("page.pause") + ' '}</b><span className="badge result-fail-sm"> </span></h6>
					)}

				</div>
			</div>
			{(surveyIndex == 0) && (
				<div className="row">
					<div className="col-sm-6">
					</div>
					<div className="col-sm-6">
						<h6 style={{ marginRight: "2vw", float: 'right' }}><b>{'  ' + t("page.incomplete") + ' '}</b><span className="badge result-incomplete-sm"> </span></h6>
					</div>
				</div>
			)}
			<div className="row" id="reportContainer" style={{ marginTop: "2vh" }}>
				<div className="col">
					<HighchartsReact key={surveyIndex} highcharts={Highcharts} containerProps={{ style: { width: widthOfReport, height: "15vh", minHeight: "10vh", maxHeight: "20vh", overfow: "visible" } }}
						options={chartOptions[survey.answerId]}
					/>
				</div>
			</div>
			<div className="row">
				<div className="col">
					<div className="placeholder-pg"></div>
				</div>
			</div>
		</div>
	)
}

export default DisplaySurveyScores;